import Vue from 'vue'

// State
const state = {
  isLoading: false,
  isSaving: false,
  data: null,
  selectedExhibition: null
}

// Mutations
const fetchExhibitionsRequest = 'fetchExhibitionsRequest'
const fetchExhibitionsResponse = 'fetchExhibitionsResponse'
const saveExhibitionRequest = 'saveExhibitionRequest'
const saveExhibitionResponse = 'saveExhibitionResponse'
export const selectExhibition = 'selectExhibition'
export const unselectExhibition = 'unselectExhibition'

const mutations = {
  [fetchExhibitionsRequest] (state) {
    state.isLoading = true
  },
  [fetchExhibitionsResponse] (state, exhibitions) {
    state.isLoading = false
    state.data = exhibitions
  },
  [saveExhibitionRequest] (state) {
    state.isSaving = true
  },
  [saveExhibitionResponse] (state, exhibition) {
    if (!state.data) {
      state.data = [exhibition]
    }
    const match = state.data.find(({ id }) => exhibition.id === id)
    if (!match) {
      state.data = [...state.data, exhibition]
    } else {
      state.data = [
        ...state.data.map(exhibionInList => {
          if (exhibionInList.id === exhibition.id) {
            return exhibition
          } else {
            return exhibionInList
          }
        })
      ]
    }
    state.isSaving = false
  },
  [selectExhibition] (state, exhibition) {
    state.selectedExhibition = exhibition
  },
  [unselectExhibition] (state) {
    state.selectedExhibition = null
  }
}

// Actions
export const fetchExhibitions = 'fetchExhibitions'
export const saveExhibition = 'saveExhibition'
const actions = {
  [fetchExhibitions]: ({ commit, dispatch }) => {
    commit(fetchExhibitionsRequest)
    return Vue.http
      .get(`${SERVER_URL}/exhibitions`)
      .then(({ data: exhibitions }) => {
        commit(fetchExhibitionsResponse, exhibitions)
      })
  },
  [saveExhibition]: ({ commit, dispatch }, exhibition) => {
    commit(saveExhibitionRequest)

    // UPDATE
    if (exhibition.id) {
      return Vue.http
        .put(`${SERVER_URL}/exhibitions/${exhibition.id}`, exhibition)
        .then(({ data: exhibition }) => {
          commit(saveExhibitionResponse, exhibition)
          return exhibition
        })
    } else {
      // CREATE
      return Vue.http
        .post(`${SERVER_URL}/exhibitions`, exhibition)
        .then(({ data: exhibition }) => {
          commit(saveExhibitionResponse, exhibition)
          return exhibition
        })
    }
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/exhibitions.js